import { type FC } from 'react'
import { Button, IconErrorCircleSolid } from '@egw/components'
import { useTranslation } from '@egw/i18n'
import { useRouter } from '@egw/router'
import { WEALTH_ROUTES } from '@egw/constants'

export const ExpiredApplicationPage: FC = () => {
  const { t } = useTranslation('features-auth')
  const { navigate } = useRouter()

  return (
    <div className="egw-container-re-entry">
      <IconErrorCircleSolid className="mb-sm mt-3xl" />
      <h2 className="typo-primary-2xl-light text-text-header-error mb-md">{t('re_entry.expired.title')}</h2>
      <p className="text-text-body typo-primary-base">{t('re_entry.expired.description')}</p>
      <div className="flex-1 md:hidden" />
      <Button
        testId="reEntry_expiredApplication_primary_btn"
        className="mt-2 w-full md:w-max md:mt-xl typo-primary-base-bold"
        onClick={() => {
          navigate(WEALTH_ROUTES.SIGN_IN.path)
        }}
      >
        {t('re_entry.expired.cta')}
      </Button>
    </div>
  )
}
